import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MenuIcon, XIcon, BriefcaseIcon } from 'lucide-react';
const navItems = [{
  label: 'Servicios',
  href: '#servicios'
}, {
  label: 'Cómo trabajamos',
  href: '#como-trabajamos'
}, {
  label: 'Clientes',
  href: '#clientes'
}, {
  label: 'Equipo',
  href: '#equipo'
}, {
  label: 'Preguntas',
  href: '#faq'
}];
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  return <nav className="bg-white border-b border-slate-200" data-id="element-138">
      <div className="max-w-7xl mx-auto px-6 py-3" data-id="element-139">
        <div className="flex items-center justify-between" data-id="element-140">
          <a href="#" className="flex items-center" data-id="element-141">
            <img src="https://cdn.magicpatterns.com/uploads/pEeqH5oN9DvER9dadcNUox/ENLACES_-_SF-Horizontal.png" alt="Enlaces Consultora" className="h-14 transition-transform duration-300 hover:scale-105" data-id="element-142" />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-6" data-id="element-143">
            {navItems.map((item, index) => <a key={index} href={item.href} className="relative text-slate-700 hover:text-emerald-600 font-medium transition-colors duration-300 group" data-id="element-144">
                {item.label}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-emerald-600 transition-all duration-300 group-hover:w-full" data-id="element-145"></span>
              </a>)}

            {/* CTA Buttons */}
            <a href="#empleo" className="inline-flex items-center px-4 py-2 text-slate-700 font-medium rounded-lg border border-slate-300 hover:border-slate-400 hover:bg-slate-50 transition-all duration-300" data-id="element-146">
              <BriefcaseIcon className="w-4 h-4 mr-2" data-id="element-147" />
              Busco empleo
            </a>

            <a href="#contacto" className="inline-flex items-center px-5 py-2.5 bg-gradient-to-r from-purple-600 to-purple-700 text-white font-semibold rounded-lg shadow-md shadow-purple-600/30 hover:shadow-lg hover:shadow-purple-600/40 transition-all duration-300" data-id="element-148">
              Contacto
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsOpen(!isOpen)} className="lg:hidden p-2 text-slate-700 hover:text-emerald-600 transition-colors" data-id="element-149">
            {isOpen ? <XIcon className="w-6 h-6" data-id="element-150" /> : <MenuIcon className="w-6 h-6" data-id="element-151" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden pt-4 pb-4" data-id="element-152">
            <div className="flex flex-col space-y-3" data-id="element-153">
              {navItems.map((item, index) => <a key={index} href={item.href} onClick={() => setIsOpen(false)} className="text-slate-700 hover:text-emerald-600 font-medium py-2 transition-colors" data-id="element-154">
                  {item.label}
                </a>)}

              {/* Mobile CTA Buttons */}
              <a href="#empleo" onClick={() => setIsOpen(false)} className="inline-flex items-center justify-center px-4 py-2.5 text-slate-700 font-medium rounded-lg border border-slate-300 hover:border-slate-400 hover:bg-slate-50 transition-all duration-300 mt-2" data-id="element-155">
                <BriefcaseIcon className="w-4 h-4 mr-2" data-id="element-156" />
                Busco empleo
              </a>

              <a href="#contacto" onClick={() => setIsOpen(false)} className="inline-flex items-center justify-center px-5 py-3 bg-gradient-to-r from-purple-600 to-purple-700 text-white font-semibold rounded-lg shadow-md shadow-purple-600/30 transition-all duration-300" data-id="element-157">
                Contacto
              </a>
            </div>
          </motion.div>}
      </div>
    </nav>;
}